
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.355.996L6.33 4.34l-3.869.851.363 3.87L.21 11.994l2.615 2.924-.363 3.88 3.87.862 2.024 3.344L12 21.459l3.644 1.535 2.026-3.344 3.869-.863-.363-3.869 2.615-2.924-2.615-2.922.363-3.87-3.87-.862L15.646.996 12 2.531 8.356.996zm1.993 3.363h3.304l-.382 11.072h-2.51L10.348 4.36zm.146 13.115h3.012v2.166h-3.012v-2.166z"}})])
          )
        }
      }
    